import { Observable } from 'rxjs';
import { Dictionary, PagedResults, ParameterValueType } from '../../core';
import { InjectionToken } from '../../injection';
import { MobizSettings } from '../data/mobiz-settings.do';
import { SystemSettings } from '../data/system-settings.do';
import { MobizSettingsKeySystem } from '../other/mobiz-settings.type';

export interface SystemSettingsQueryParameters extends Dictionary<ParameterValueType> {
  valueSchema?: string;
}

export interface ISystemSettingsService {
  getAll(queryParameters?: SystemSettingsQueryParameters): Observable<PagedResults<MobizSettings<SystemSettings>>>;

  get(key: MobizSettingsKeySystem): Observable<MobizSettings<SystemSettings>>;

  set(
    key: MobizSettingsKeySystem,
    instance: MobizSettings<SystemSettings>,
  ): Observable<MobizSettings<SystemSettings>>;
}

export const ISystemSettingsService = new InjectionToken('ISystemSettingsService');
